import { useEffect, useState } from "react";
import { ArrowLeft, CheckCircle2, CreditCard, ClipboardCheck, FileText, ListChecks, Trophy } from "lucide-react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { toast } from "sonner";
import { api, download } from "@/lib/api";

const fmtMonth = (m) => new Date(`${m}-01`).toLocaleDateString("id-ID", { month: "short", year: "numeric" });

const Item = ({ x, ach }) => (
  <div className="record-row" data-testid={`profile-history-${x.id}`}>
    <div className={`record-icon ${ach || x.kind === "Positif" ? "positive" : "coaching"}`}>{ach ? <Trophy size={16} /> : x.kind === "Positif" ? <CheckCircle2 size={16} /> : <ClipboardCheck size={16} />}</div>
    <div className="record-main"><b>{x.category}{ach ? ` · ${x.level}` : ` · ${x.kind}`}</b><span>{x.description}</span></div>
    <span className={`status ${x.verification === "Terverifikasi" ? "verified" : "waiting"}`}>{x.verification}</span>
    <small>{x.date}</small>
  </div>
);

export const StudentProfile = ({ id, back }) => {
  const [p, setP] = useState(null);
  const [tab, setTab] = useState("discipline");
  useEffect(() => { api(`/students/${id}/profile`).then(setP).catch((e) => { toast.error(e.message); back(); }); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!p) return <div className="loading" data-testid="profile-loading">Memuat profil siswa…</div>;
  const s = p.student;
  const rows = tab === "discipline" ? p.discipline : p.achievements;
  return (
    <div data-testid="student-profile-page">
      <button className="text-btn" onClick={back} data-testid="profile-back-button"><ArrowLeft size={15} /> Kembali</button>
      <div className="page-heading compact">
        <div className="profile-id">
          <div className="profile-big-avatar">{s.name.slice(0, 1)}</div>
          <div><p className="eyebrow">PROFIL PERKEMBANGAN SISWA</p><h1 data-testid="profile-student-name">{s.name}</h1>
            <p className="muted">NIS {s.nis} · NISN {s.nisn || "-"} · {s.class_name} · {s.major} · {s.gender}</p>
            <p className="muted small-note" data-testid="profile-phones">WA siswa: {s.phone || "belum diisi"} · Wali{s.parent_name ? ` (${s.parent_name})` : ""}: {s.parent_phone || "belum diisi"}</p></div>
        </div>
        <div className="row-actions"><button className="outline-btn" onClick={() => download(`/students/cards/pdf?student_id=${s.id}`)} data-testid="profile-card-button"><CreditCard size={16} /> Kartu siswa</button><button className="primary-btn" onClick={() => download(`/export/pdf?kind=student&student_id=${s.id}`)} data-testid="profile-export-pdf-button"><FileText size={16} /> Unduh PDF</button></div>
      </div>
      <div className="stats-grid">
        {[["Perilaku positif", p.summary.positive, "green", CheckCircle2], ["Perlu pembinaan", p.summary.coaching, "amber", ClipboardCheck], ["Prestasi", p.summary.achievements, "rose", Trophy], ["Total catatan", p.summary.total, "blue", ListChecks]].map(([l, v, c, Icon]) => (
          <div className="stat-card" key={l} data-testid={`profile-stat-${c}`}><div className={`stat-icon ${c}`}><Icon size={19} /></div><div><span>{l}</span><strong>{v}</strong></div></div>
        ))}
      </div>
      <section className="panel chart-panel profile-chart">
        <div className="panel-head"><div><h3>Grafik perkembangan bulanan</h3><p>Perbandingan catatan positif, pembinaan, dan prestasi</p></div></div>
        <div style={{ height: 260, padding: "0 16px 16px" }} data-testid="profile-chart">
          {p.monthly.length ? (
            <ResponsiveContainer><BarChart data={p.monthly}><CartesianGrid strokeDasharray="3 3" vertical={false} /><XAxis dataKey="month" fontSize={11} interval={0} tickFormatter={fmtMonth} /><YAxis allowDecimals={false} fontSize={11} /><Tooltip /><Legend />
              <Bar dataKey="positive" name="Positif" fill="#059669" radius={[3, 3, 0, 0]} /><Bar dataKey="coaching" name="Pembinaan" fill="#f59e0b" radius={[3, 3, 0, 0]} /><Bar dataKey="achievements" name="Prestasi" fill="#e11d48" radius={[3, 3, 0, 0]} />
            </BarChart></ResponsiveContainer>
          ) : <div className="empty">Belum ada data untuk grafik.</div>}
        </div>
      </section>
      <div className="recap-tabs">
        <button className={tab === "discipline" ? "active" : ""} onClick={() => setTab("discipline")} data-testid="profile-tab-discipline"><ClipboardCheck size={17} /> Riwayat disiplin ({p.discipline.length})</button>
        <button className={tab === "achievements" ? "active" : ""} onClick={() => setTab("achievements")} data-testid="profile-tab-achievements"><Trophy size={17} /> Riwayat prestasi ({p.achievements.length})</button>
      </div>
      <section className="panel table-panel"><div className="record-list">
        {rows.length ? rows.map((x) => <Item key={x.id} x={x} ach={tab === "achievements"} />) : <div className="empty">Belum ada catatan.</div>}
      </div></section>
    </div>
  );
};
